import account from './account/routes'
import consult from './consult/routes'
import maneuver from './maneuver/routes'
import scrapping from './scrapping/routes'
import setting from './setting/routes'
import invoicing from './invoicing/routes'

const routes = {
  index: {
    path: 'index',
    url: '/',
  },
  home: {
    path: 'index.home',
    url: 'accueil',
  },
  account,
  consult,
  maneuver,
  scrapping,
  setting,
  invoicing,
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/routes.js